module.exports = __webpack_public_path__ + "img/Samoa.886da44d.png";